import { useEffect, useState } from "react";
import { getDashboardPermisions } from "../services/newAPI";
import DashboardContext from "./DashboardContext";
import { getProducts } from "../services/SubmitEstablishment";

export default function DashboardProvider({ children }) {
  const [permissions, setPermissions] = useState(null);
  const [totalWorkers, setTotalWorkers] = useState(null);
  const [loadingPermissions, setLoadingPermissions] = useState(true);
  const [editMember, setEditMember] = useState({});
  const [products, setProducts] = useState([]);
  const [primaryColorInput, setPrimaryColorInput] = useState("");
  const [panelTitle, setPanelTitle] = useState(
    JSON.parse(sessionStorage.getItem("panelTitle"))
  );
  const [customPrimaryColor, setCustomPrimaryColor] = useState(
    JSON.parse(sessionStorage.getItem("customPrimaryColor")) || "#539957"
  );
  const [isMemberDrawerOpen, setIsMemberDrawerOpen] = useState(false);
  const [isEstablishmentDrawerOpen, setIsEstablishmentDrawerOpen] =
    useState(false);
  const [clientId, setClientId] = useState(
    JSON.parse(sessionStorage.getItem("clientId"))
  );
  const [clientCnpj, setClientCnpj] = useState(
    JSON.parse(localStorage.getItem("clientCnpj"))
  );
  const [clientUser, setClientUser] = useState(
    JSON.parse(sessionStorage.getItem("clientUser"))
  );
  const [clientPassword, setClientPassword] = useState(
    JSON.parse(sessionStorage.getItem("clientPassword"))
  );
  const [clientLogo, setClientLogo] = useState(
    JSON.parse(sessionStorage.getItem("clientLogo"))
  );
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [colorInputError, setColorInputError] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [typeClient, setTypeClient] = useState(
    sessionStorage.getItem("typeClient") || "cpf"
  );
  const [clientCpf, setClientCpf] = useState(
    sessionStorage.getItem("clientCpf")
  );
  const [editName, setEditName] = useState(sessionStorage.getItem("editName"));
  const [editCpf, setEditCpf] = useState(sessionStorage.getItem("editCpf"));
  const [editId, setEditId] = useState(
    JSON.parse(sessionStorage.getItem("editId")) || ""
  );
  const [master, setMaster] = useState(false);
  const [editCategorieName, setEditCategorieName] = useState(
    sessionStorage.getItem("editCategorieName") || ""
  );
  const [categorieId, setCategorieId] = useState(
    sessionStorage.getItem("categorieID") || ""
  );
  const [qrcodeLink, setQrcodeLink] = useState(
    sessionStorage.getItem("qrcodeLink") || ""
  );
  const [movementUrl, setMovementUrl] = useState(
    sessionStorage.getItem("movementUrl") || ""
  );
  const [token, setToken] = useState(localStorage.getItem("token") || "");

  const [nodeToken, setNodeToken] = useState(
    localStorage.getItem("nodeToken") || ""
  );

  const drawerWidth = 540;

  const hexRegEx = /[a-fA-F0-9]/;

  const primaryColorInputHandler = ({ target: { value } }) => {
    if (value.split("").every((character) => character.match(hexRegEx)))
      setPrimaryColorInput(value);
  };

  const primaryColorSubmit = (event) => {
    event.preventDefault();
    if (primaryColorInput.length === 6) {
      setColorInputError(false);
      setCustomPrimaryColor(`#${primaryColorInput}`);
    } else {
      setColorInputError(true);
    }
  };

  const fetchPermissions = async () => {
    const actToken = localStorage.getItem("nodeToken") || "";
    const id = JSON.parse(sessionStorage.getItem("clientId"));
    setLoadingPermissions(true);
    try {
      const perms = await getDashboardPermisions({ actToken, id });
      setPermissions(perms);
      return perms;
    } catch (error) {
      console.error("Failed to fetch permissions:", error);
    } finally {
      setLoadingPermissions(false);
    }
  };

  useEffect(() => {
    const actToken = localStorage.getItem("nodeToken") || "";

    const getCompanyproducts = async () => {
      try {
        const data = await getProducts(actToken);
        setProducts(data);
      } catch (err) {
        console.log(err);
      }
    }

    getCompanyproducts();
  }, [clientId]);

  const context = {
    loadingPermissions,
    totalWorkers,
    products,
    setTotalWorkers,
    fetchPermissions,
    permissions,
    editMember,
    setEditMember,
    primaryColorInputHandler,
    primaryColorSubmit,
    customPrimaryColor,
    primaryColorInput,
    drawerWidth,
    isMemberDrawerOpen,
    setIsMemberDrawerOpen,
    isEstablishmentDrawerOpen,
    setIsEstablishmentDrawerOpen,
    clientId,
    setClientId,
    clientCnpj,
    setClientCnpj,
    clientUser,
    setClientUser,
    clientPassword,
    setClientPassword,
    isLoggedIn,
    setIsLoggedIn,
    setCustomPrimaryColor,
    panelTitle,
    setPanelTitle,
    clientLogo,
    setClientLogo,
    colorInputError,
    admin,
    setAdmin,
    typeClient,
    setTypeClient,
    clientCpf,
    setClientCpf,
    editName,
    setEditName,
    editCpf,
    setEditCpf,
    master,
    setMaster,
    editCategorieName,
    setEditCategorieName,
    categorieId,
    setCategorieId,
    qrcodeLink,
    setQrcodeLink,
    movementUrl,
    setMovementUrl,
    editId,
    setEditId,
    token,
    setToken,
    nodeToken,
    setNodeToken,
  };

  return (
    <DashboardContext.Provider value={context}>
      {children}
    </DashboardContext.Provider>
  );
}
